import CollapsibleModule from './collapsible.module'

export default CollapsibleModule
